import React from 'react';
import { createUseStyles } from 'react-jss';
import { useDialog } from '../../../hooks/useDialog';
import { useTranslation } from 'react-i18next';
import winImage from '../../../assets/images/win.png';
import loseImage from '../../../assets/images/lose.png';
import { Button } from '../../Common/Button';

const useStyles = createUseStyles({
    dialog: {
        maxWidth: 800,
        width: '70%',
        padding: '0.5rem 1rem',
        border: '1px solid black',
        backgroundColor: '#f5e7ec',
        flexDirection: 'column',
        '&:modal': {
            display: 'flex',
        },
    },
    root: {
        position: 'relative',
        width: '100%',
        height: '100%',
        display: 'grid',
        gap: '1rem',
        gridTemplate: '"text image" "controls image" / 1fr 1fr',
    },
    title: {
        margin: 0,
    },
    text: {
        gridArea: 'text',
    },
    controls: {
        gridArea: 'controls',
        display: 'flex',
        flexDirection: 'column-reverse',
    },
    image: {
        gridArea: 'image',
        width: '300px',
    },
});
interface IWinDialogProps {
    score: number;
    days: number;
    onShowMenu(): void;
}

export const WinDialog: React.FunctionComponent<IWinDialogProps> = (props) => {
    const styles = useStyles();
    const { t } = useTranslation();

    return <article className={styles.root}>
        <div className={styles.text}>
            <h2 className={styles.title}>{t('game.winDialog.title')}</h2>
            <p>{t('game.winDialog.text', { value: props.days })}</p>
            <p>{t('game.winDialog.score', { value: props.score })}</p>
        </div>
        <div className={styles.controls}>
            <Button onClick={props.onShowMenu}>{t('backToMenu')}</Button>
        </div>
        <img src={winImage} alt={t('game.winDialog.alt')} className={styles.image} />
    </article>;
};

export const useWinDialog = (score: number, days: number, onShowMenu: () => void) => {
    const styles = useStyles();
    return useDialog({
        children: <WinDialog score={score} days={days} onShowMenu={onShowMenu}/>,
        className: styles.dialog,
    });
};
